import { DeleteOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps } from "antd";
import * as React from "react";
import { DeleteConfirm } from "src/components/DeleteConfirm";

type PropsCatalogCardActions = {
  deleteTask(): Promise<void>;
};

export const CatalogCardActions: React.FC<PropsCatalogCardActions> = (
  props,
) => {
  const { deleteTask } = props;
  const [deleting, setDeleting] = React.useState(false);
  const items: MenuProps["items"] = [
    {
      key: "delete",
      danger: true,
      icon: <DeleteOutlined />,
      label: "Удалить",
      onClick: () => setDeleting(true),
    },
  ];
  return (
    <>
      <Dropdown trigger={["click"]} menu={{ items }}>
        <Button icon={<MoreOutlined />} />
      </Dropdown>
      <DeleteConfirm
        content="Удалить каталог?"
        open={deleting}
        close={() => setDeleting(false)}
        task={deleteTask}
      />
    </>
  );
};
